import { z } from 'zod'

export const RegisterFormSchemaZ = z
  .object({
    email: z
      .string()
      .min(1, { message: 'Pole jest wymagane' })
      .email({ message: 'Nieprawidłowy adres email' }),
    username: z.string().min(1, { message: 'Pole jest wymagane' }),
    password: z.string().min(8, { message: 'Hasło musi mieć minimum 8 znaków' }),
    confirmPassword: z.string().min(1, { message: 'Pole jest wymagane' }),
    acceptTerms: z.boolean().refine(val => val === true, {
      message: 'Akceptacja regulaminu jest wymagana'
    })
  })
  .refine(data => data.password === data.confirmPassword, {
    message: 'Hasła muszą być takie same',
    path: ['confirmPassword']
  })

export type RegisterFormSchema = z.infer<typeof RegisterFormSchemaZ>
